import request from "@/utils/request";

/**
 * 购彩彩票列表接口
 *
 * @description 购彩彩票列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryList(playload, config) {
  return request({
    url: "/api/lottery/queryLotteryList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 根据玩法ID、彩种ID查询页面布局和赔率返利信息
 *
 * @description 根据玩法ID、彩种ID查询页面布局和赔率返利信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPlayLayoutByBettingId(playload, config) {
  return request({
    url: "/api/lottery/queryPlayLayoutByBettingId",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 彩票详情接口（拆分服务：只有默认玩法返回布局界面）
 *
 * @description 获取彩票投注方式信息（拆分服务）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
// 56.彩票详情接口（拆分服务：只有默认玩法返回布局界面）
export async function getLotteryDetailV2(playload, config) {
  return request({
    url: "/api/lottery/getLotteryDetailV2",
    method: "POST",
    data: playload,
    noEncrypt: true,
    // timeout: 5000,
    ...config
  });
}
/**
 * 彩票下注接口
 *
 * @description 获取详细设定信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function betting(playload, config) {
  return request({
    url: "/api/lottery/betting",
    method: "POST",
    data: playload,
    timeout: 5000,
    ...config
  });
}
/**
 * 彩票历史开奖记录列表接口
 *
 * @description 彩票历史开奖记录列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPrizeHistoryListV2(playload, config) {
  return request({
    url: "/api/lottery/queryPrizeHistoryList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 聊天室彩票开奖信息列表接口
 *
 * @description 聊天室彩票开奖信息列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryChatPrizeList(playload) {
  return request({
    url: "/api/lottery/queryChatPrizeList",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 彩票首页中奖排行榜（PC首页）
 *
 * @description 彩票首页中奖排行榜（PC首页）
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPrizeRankingList(playload) {
  return request({
    url: "/api/lottery/queryPrizeRankingList",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 详细设定接口
 *
 * @description 详细设定接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryPlayList(playload, config) {
  return request({
    url: "/api/lottery/queryLotteryPlayList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 玩法规则接口
 *
 * @description 玩法规则接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryTypeRuleList(playload, config) {
  return request({
    url: "/api/lottery/queryLotteryTypeRuleList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
/**
 * 彩票开奖信息列表接口
 *
 * @description 彩票开奖信息列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryPrizeList(playload, config) {
  return request({
    url: "/api/lottery/queryPrizeList",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
/**
 * 彩票期数列表接口
 *
 * @description 彩票期数列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRecordListV2(playload, config = {}) {
  return request({
    url: "/api/lottery/queryLotteryRecordListV2",
    method: "POST",
    data: playload,
    noEncrypt: true,
    // timeout: 5000,
    ...config
  });
}
/**
 * 彩票历史开奖记录列表接口
 *
 * @description 彩票历史开奖记录列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
/* export async function queryPrizeHistoryList(playload) {
  return request({
    url: "/api/lottery/queryPrizeHistoryList",
    method: "POST",
    data: playload,
    loading: true,
    noEncrypt: true
  });
} */
/**
 * 彩票期数列表接口
 *
 * @description 彩票期数列表接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryLotteryRecordList(playload, config = {}) {
  return request({
    url: "/api/lottery/queryLotteryRecordList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
export async function getLotteryDetail(playload, config = {}) {
  return request({
    url: "/api/lottery/getLotteryDetail",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}

/**
 * 彩票期数列表接口
 *
 * @description 长龙接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */

export async function dragon(playload, config = {}) {
  return request({
    url: "/api/lottery/lottery/dragon",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
export async function queryOpencodes(playload, config) {
  return request({
    url: "/api/lottery/trend/queryOpencodes",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
export async function queryBettingInfoList(playload, config) {
  return request({
    url: "/api/lottery/betting/queryBettingInfoList",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
export async function queryBetInfo(playload, config) {
  return request({
    url: "/api/lottery/betting/queryBetInfo",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
export async function queryhot(playload, config) {
  return request({
    url: "/api/lottery/hot",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
export async function ruleDesc(typeId) {
  return request({
    url: `/api/lottery/ruleDesc?typeId=${typeId}`,
    method: "GET",
    noEncrypt: true
  });
}
export async function userInfo(playload, config) {
  return request({
    url: "/api/user/info/userInfo",
    method: "GET"
  });
}
export async function EmrgLists(playload, config) {
  return request({
    url: "/api/lottery/trend/EmrgLists",
    method: "POST",
    data: playload,
    noEncrypt: true,
    ...config
  });
}
